(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/xperten/javascripts/xperten-wrapper.js') >= 0) return;  svs.modules.push('/components/sport/xperten/javascripts/xperten-wrapper.js');
'use strict';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
class XpertenWrapper extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      selectedXpert: this.props.selectedXpert,
      useBaseRow: !svs.sport.xperten.isBaseRowEmpty(this.props.baseRow),
      ownBaseRow: undefined
    });
    this.changeSelectedXpert = this.changeSelectedXpert.bind(this);
    this.changeUseBaseRow = this.changeUseBaseRow.bind(this);
    this.changeOwnBaseRow = this.changeOwnBaseRow.bind(this);
  }
  componentDidMount() {
    svs.components.Modal.show(React.createElement(svs.components.ReactSwiper, null, React.createElement(svs.sport.xperten.Xperten, _extends({}, this.props, {
      changeOwnBaseRow: this.changeOwnBaseRow,
      changeSelectedXpert: this.changeSelectedXpert,
      changeUseBaseRow: this.changeUseBaseRow,
      useBaseRow: this.state.useBaseRow
    }))), {}, {
      title: 'PIX!',
      headerClass: this.props.modalHeaderClass,
      onHideByBrowserBack: this.props.closeXperten,
      dontPushModalToHistory: !svs.core.detect.formfactor.mobile(),
      leftButton: {
        visible: true,
        text: 'Avbryt',
        cssClass: 'btn-transparent-inverted',
        callback: () => {
          this.props.closeXperten();
          return true;
        }
      },
      rightButton: {
        text: 'Klar',
        cssClass: 'btn-transparent-inverted',
        disabled: true,
        callback: () => {
          if (this.state.ownBaseRow) {
            this.props.startEditBaseRow(this.state.selectedXpert, this.props.drawNumber);
          } else {
            this.props.generateXpert(this.props.drawNumber, this.state.selectedXpert, this.state.useBaseRow);
          }
          this.props.closeXperten();
          return true;
        }
      }
    });
  }
  componentWillUnmount() {
    svs.components.Modal.hide();
  }
  changeSelectedXpert(xpert) {
    this.setState({
      selectedXpert: xpert
    });
  }
  changeUseBaseRow() {
    this.setState(state => ({
      useBaseRow: !state.useBaseRow
    }));
  }
  changeOwnBaseRow() {
    this.setState(state => ({
      ownBaseRow: state.ownBaseRow ? undefined : true
    }));
  }
  render() {
    return null;
  }
}
XpertenWrapper.defaultProps = {
  closeXperten: () => {},
  generateXpert: () => {},
  modalHeaderClass: '',
  xperter: []
};
svs.sport.xperten.XpertenWrapper = XpertenWrapper;
svs.sport.xperten.isBaseRowEmpty = baseRow => {
  let isEmpty = true;
  for (const prop in baseRow) {
    if (Object.prototype.hasOwnProperty.call(baseRow, prop) && prop !== 'halfHedges' && prop !== 'fullHedges') {
      if (baseRow[prop]) {
        isEmpty = false;
      }
    }
  }
  return isEmpty;
};

 })(window);